import React, { useRef } from 'react'
import { Link } from 'gatsby'
import { Container, Col, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faEnvelope, faLock, faTruck } from '@fortawesome/free-solid-svg-icons'
import { StaticImage } from 'gatsby-plugin-image'
import { Logo, LogoSmall } from '/src/components/common'
import FooterMenu from '/src/components/navigation/FooterMenu'
import FooterProductMenu from '/src/components/navigation/FooterProductMenu'
import SocialList from '/src/components/social/SocialList'
import NearestStore from '/src/components/common/nearestStore'
import Header from '/src/components/layout/Header'
import HomeImageCarousel from '/src/components/carousel/HomeImageCarousel'
import { SubscribeBlock, XmasModal } from '/src/components/common'
import { LiveAgent } from '/src/components/chat'

const images = [
  /*{
    title: 'CHRISTMAS & NEW YEAR TRADING 2023',
    content: '<h1>CHRISTMAS & NEW YEAR TRADING 2023</h1><h2>WISHING YOU HAPPY AND SAFE CHRISTMAS AND NEW YEAR</h2><p>Please click link for your local branches trading hours</p>',
    image: "https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/s3fs-public/2023-11/slides/MC-XMAS-Web.jpg",
    link: {
      title: 'CHRISTMAS & NEW YEAR TRADING 2023',
      href: '/resources/latest-news/2023-11-28-christmas-new-year-trading-0'
    }
  },*/
  {
    title: 'THE METALCORP END OF FINANCIAL YEAR SALE',
    content: '<h1>THE METALCORP END OF FINANCIAL YEAR SALE</h1><h2>HURRY SALE ENDS JUNE 30th 2024</h2><p>SEE CATALOGUE FOR SPECIALS</p>',
    image: "https://metalcorp-static-assets.s3.ap-southeast-2.amazonaws.com/s3fs-public/EOFYS-web-banner-slider.jpg",
    link: {
      title: 'METALCORP END OF FINANCIAL YEAR SALE',
      href: '/resources/catalogues-brochures'
    }
  },
  {
    title: 'VR Yard Viewer',
    content: '<h1>VR YARD VIEWER&nbsp;</h1><h2>VISUALISE YOUR NEW YARD ON YOUR PROPERTY</h2><p>MASSIVE RANGE AVAILABLE TO VIEW!</p>',
    image: "https://metalcorp-drupal-assets.s3.ap-southeast-2.amazonaws.com/s3fs-public/2023-03/products/cattlemaster-crush-gal-3.jpg",
    link: {
      title: 'VR Yard Viewer',
      href: 'https://orrcon-apps-virtual-yard-experience-v01bslau-tst-aes.azurewebsites.net/#v1/15%20Working%20Capacity///brand=CATTLEKING'
    }
  },
  {
    title: 'Safe Farming',
    content: '<h2>Safe Farming&nbsp;</h2><h1>Tick Of Approval</h1><p>Metalcorp&nbsp;livestock handling equipment has received a Safe Farming Tick Of Approval by the&nbsp;National Centre for Farmer Health.</p>',
    image: "https://metalcorp-static-assets.s3.ap-southeast-2.amazonaws.com/s3fs-public/2020-11/products/cattleking-ramp-walkway-ext-3600-3.jpg",
    link: {
      title: 'What is the tick of approval',
      href: '/community/tick-approval'
    }
  },
  /*{
    title: 'Buy Online',
    content: '<h2 class="background-text">Online Shopping Now Available</h2><h1>Convenience Redefined</h1><p>Order safely and securely from any internet enabled device.</p>',
    image: "https://metalcorp-static-assets.s3.ap-southeast-2.amazonaws.com/s3fs-public/2021-02/products/angle-bar-equal-yellow-2-10.jpg"
  }*/
]

export default ({ children }) => {
  const elementRef = useRef()

  return (
    <div ref={elementRef} className="app">
      <Header elementRef={elementRef} />

      <div className="carousel">
        <Container fluid="xxl">
          <Row>
            <HomeImageCarousel images={images} />
          </Row>
        </Container>
      </div>

      <div className="your-rural-brand">
        <Container fluid="xxl">
          <Row>
            <Col sm={12} className='d-flex align-items-center justify-content-center'>
              <div className='content mb-5'>
                <h1 className="mt-5 mb-3">Your rural brand for the land</h1>
                <p>Metalcorp is an Australian steel distribution business that is into everything in steel.</p>
                <p>With huge stock holdings, our products can be cut to length and delivered to site.</p>
              </div>
            </Col>
          </Row>
          <Row className="badges pt-5 pb-5">
            <Col md={4} className="d-flex align-items-center justify-content-center">
              <h3>
                <FontAwesomeIcon icon={faLock} />
                100% SECURE
              </h3>
            </Col>
            <Col md={4} className="d-flex align-items-center justify-content-center">
              <h3>
                <FontAwesomeIcon icon={faTruck} />
                PICKUP / DELIVERY
              </h3>
            </Col>
            <Col md={4} className="d-flex align-items-center justify-content-center">
              <h3>
                <FontAwesomeIcon icon={faTruck} />
                AUSTRALIAN OWNED
              </h3>
            </Col>
          </Row>
        </Container>
      </div>

      <main>
        <Container>
          <Row className="d-flex justify-content-center">
            <Col xs={12}>
              {children}
            </Col>
          </Row>
        </Container>
        <div className="subscribe-block-wrapper pt-5 mt-5">
          <Container fluid="xxl">
            <Row className="d-flex align-items-center mb-5">
              <Col xs={12}>
                <SubscribeBlock />
              </Col>
            </Row>
          </Container>
        </div>
      </main>

      <footer>
        <Container fluid="xxl">
          <Row className="footer-top-row d-flex align-items-center mb-4">
            <Col sm={5} md={3}>
              <h3 className="m-0">
                <a className="phone-link" href="tel:1300306204">
                  <FontAwesomeIcon icon={faPhone} />1300 306 204
                </a>
              </h3>
            </Col>
            <Col sm={7} md={6}>
              <h3 className="m-0">
                <a className="email-link" href="mailto:sales@metalcorpsteel.com.au">
                  <FontAwesomeIcon icon={faEnvelope} />sales@metalcorpsteel.com.au
                </a>
              </h3>
            </Col>
            <Col sm={6} md={3}>
              <SocialList />
            </Col>
          </Row>
          <Row className="d-flex align-items-center">
            <Col sm={6} md={3}>
              <FooterProductMenu />
            </Col>
            <Col sm={6} md={3}>
              <FooterMenu />
            </Col>
            <Col sm={6} md={3}>
              <NearestStore />
            </Col>
            <Col sm={6} md={3}>
              <h6 className="mb-4 text-uppercase">Head Office</h6>
              <span>920 Nudgee Rd, <br/>Banyo QLD 4013</span>
              <LogoSmall />
            </Col>
          </Row>
        </Container>
      </footer>

      <div className="footer-bottom">
        <Container fluid="xxl">
          <Row className="d-flex align-items-center">
            <Col sm={6}>
              <div className="footer-copyright">
                <span>
                  <StaticImage 
                    src="../../../images/BlueScope-Blue-Metalcorp-is-a-BlueScope-Company.png" 
                    alt="Bluescope"
                    width={397}
                    height={41}
                    quality={100}
                    placeholder="blurred"
                    imgStyle={{ objectFit: 'contain' }}
                    layout="fixed" />
                </span>
                <ul className="list first">
                  <li>
                    <Link to="/terms-conditions">
                      Terms
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">
                      Privacy
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>
            <Col sm={6} className="d-flex justify-content-end">
              <ul className="list">
                <li>
                  <StaticImage 
                    src="../../../images/paypal.svg" 
                    alt="Paypal"
                    width={72}
                    height={20}
                    placeholder="blurred"
                    layout="fixed" />
                </li>
                <li>
                  <StaticImage 
                    src="../../../images/mastercard.svg" 
                    alt="Mastercard"
                    width={54}
                    height={42}
                    placeholder="blurred"
                    layout="fixed" />
                </li>
                <li>
                  <StaticImage 
                    src="../../../images/visa.svg"
                    alt="Visa"
                    width={56}
                    height={20}
                    placeholder="blurred"
                    layout="fixed" />
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
      <LiveAgent />
    </div>
  )
}
